<template>
  <div>
    <div class="billImage">
      <img v-bind:src="`data:image/png;base64,${billImage}`" alt="" />
    </div>
    <div class="wrapper">
      <div class="form-item form-error-out" v-if="error">
        <div class="form-error">
          <div class="error-icon">
            <img src="@/assets/icon/error.png" alt="" />
          </div>
          <div class="error-message">
            <p v-html="errorMessage"></p>
          </div>
        </div>
      </div>
      <div class="form-item form-error-out" v-if="globalError">
        <div class="form-error">
          <div class="error-icon">
            <img src="@/assets/icon/error.png" alt="" />
          </div>
          <div class="error-message">
            <p v-html="globalErrorMessage"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/EventBus.js";
import Vue from "vue";
export default {
  name: "login",
  data() {
    return {
      billImage: "",
      error: false,
      uerror: false,
      isDisabled: false,
      errorMessage: "",
    };
  },
  methods: {
    //user redirect login
    onSubmit(myToken) {
      this.$insProgress.start();
      this.$axiosApi
        .post(`card/get/billImage`, {
          tokenId: myToken,
          type: "CheckUrl",
        })
        .then((response) => {
          if (response.data.status === 1) {
            this.billImage = response.data.data;
            this.$insProgress.finish();
          } else {
            Vue.prototype.globalError = false;
            this.errorMessage = response.data.message;
            this.error = true;
            this.$insProgress.finish();
          }
        })
        .catch((error) => {
          this.error = true;
          this.errorMessage = error;
          Vue.prototype.globalError = false;
          this.$insProgress.finish();
        });
    },
    setRedirectError(message, type) {
      this.error = type;
      this.errorMessage = message;
    },
  },
  created() {
    if (
      this.$route.params.tokenId !== null &&
      this.$route.params.tokenId !== ""
    ) {
      this.onSubmit(this.$route.params.tokenId);
    }
  },
};
</script>

<style>
.billImage {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  max-width: 100%;
  max-height: 100%;
  bottom: 0;
  left: 0;
  margin: auto;
  overflow: auto;
  position: fixed;
  right: 0;
  top: 0;
  -o-object-fit: contain;
  object-fit: contain;
}
</style>
